import React, { FunctionComponent, ButtonHTMLAttributes } from 'react';
import { useTracking, TrackingData } from '@justgiving/react-tracking';
import classNames from 'classnames';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'submit' | 'reset' | 'button';
  fullWidth?: boolean;
  onClick?(ev: React.MouseEvent): void;
  trackingData?: TrackingData;
  outlined?: boolean;
  applyBranding?: boolean;
}

/* eslint-disable react/button-has-type */
export const Button: FunctionComponent<ButtonProps> = ({
  className,
  fullWidth = true,
  trackingData,
  outlined,
  onClick,
  applyBranding = true,
  ...props
}) => {
  const track = useTracking();

  const onClickWithTracking = (e: React.MouseEvent<HTMLElement>) => {
    if (trackingData) {
      track({ ...trackingData });
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button
      className={classNames(
        'jg-btn',
        {
          'jg-btn--themed': applyBranding,
          'jg-btn--auto-width': !fullWidth,
          'jg-btn--ghost': outlined,
        },
        className,
      )}
      onClick={onClickWithTracking}
      {...props}
    >
      {props.children}
    </button>
  );
};

export default Button;
